export class ManualInjector {
    static injector;
}
